import { IAutoTablePDFConfig } from "./IAutoTablePDFConfig";


export class AutoTablePDFConfig implements IAutoTablePDFConfig{
   


    constructor(){
        this.Page={formato:'A4',orientamento:'l',title:''};
        this.HeaderPage=[];
        this.Headers=[];
        this.Rows=[];
        this.FooterPage=[];
    }

    Page: { formato?: string; orientamento?: "p" | "portrait" | "l" | "landscape"; title: string; };
    HeaderPage: { text: string; align: string; }[];
    Headers: { field: string; caption: string; align?: string; width?: "auto" | "wrap" | number; isRelated?: boolean; api?: string; display?: string[]; separatore?: string; }[];
    Rows: any[];
    FooterPage: { text: string; align: string; }[];
    

    
}